import React, { useState, useEffect } from 'react';

function Mascot() {
  const [isVisible, setIsVisible] = useState(true);
  const [message, setMessage] = useState('👋 Hi! I\'m your wellness buddy!');
  const [isAnimating, setIsAnimating] = useState(false);

  const messages = [
    '👋 Hi! I\'m your wellness buddy!',
    '💪 You\'re doing great! Keep going!',
    '🌟 Remember to take care of yourself today!',
    '😊 Mental health matters. You matter!',
    '🧘 Take a deep breath and relax.',
    '❤️ Be kind to yourself always!',
    '🎯 One step at a time. You\'ve got this!',
    '✨ Every moment is a chance to grow!',
    '💭 How are you feeling today?',
    '🌈 Your wellness journey is important!'
  ];

  const showRandomMessage = () => {
    setIsAnimating(true);
    const randomIndex = Math.floor(Math.random() * messages.length);
    setMessage(messages[randomIndex]);
    setTimeout(() => {
      setIsAnimating(false);
    }, 500);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      showRandomMessage();
    }, 10000); // Show new message every 10 seconds

    return () => clearInterval(interval);
  }, []);

  if (!isVisible) return null;

  return (
    <div
      className="mascot-container"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 999,
        cursor: 'pointer',
        maxWidth: '300px'
      }}
    >
      {/* Mascot Character */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          animation: isAnimating ? 'bounce 0.5s ease-in-out' : 'none'
        }}
        onClick={showRandomMessage}
      >
        {/* Character Image */}
        <div
          className="mascot-character"
          style={{
            width: '85px',
            height: '95px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
            marginBottom: '6px'
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.12) translateY(-4px)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1) translateY(0)')}
        >
          <img
            src="/assets/images/mascot/medication.jpeg"
            alt="Wellness Buddy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              mixBlendMode: 'multiply',
              filter: 'drop-shadow(0 8px 16px rgba(102, 126, 234, 0.35))'
            }}
          />
        </div>

        {/* Message Bubble */}
        <div
          className="message-bubble"
          style={{
            backgroundColor: '#fff',
            borderRadius: '15px',
            padding: '12px 16px',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            marginBottom: '10px',
            fontSize: '13px',
            lineHeight: '1.4',
            textAlign: 'center',
            color: '#333',
            maxWidth: '250px',
            wordWrap: 'break-word',
            animation: isAnimating ? 'fadeInUp 0.5s ease-in-out' : 'none',
            opacity: 0.95
          }}
        >
          {message}
          {/* Tail */}
          <div
            style={{
              position: 'absolute',
              bottom: '-8px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '0',
              height: '0',
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '8px solid #fff'
            }}
          ></div>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}
        >
          <button
            onClick={showRandomMessage}
            style={{
              backgroundColor: '#667eea',
              color: '#fff',
              border: 'none',
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#5568d3';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#667eea';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            💬 Chat
          </button>
          <button
            onClick={() => window.open('/self-help', '_blank')}
            style={{
              backgroundColor: '#764ba2',
              color: '#fff',
              border: 'none',
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#653a8a';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#764ba2';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            🛠️ Tools
          </button>
          <button
            onClick={() => setIsVisible(false)}
            style={{
              backgroundColor: '#ccc',
              color: '#333',
              border: 'none',
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#aaa';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#ccc';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* Floating Animation Keyframes */}
      <style>{`
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .mascot-container {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}

export default Mascot;
